import { render, staticRenderFns } from "./Upsells.vue?vue&type=template&id=02a4ceb3&scoped=true"
import script from "./Upsells.vue?vue&type=script&lang=js"
export * from "./Upsells.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4ceb3",
  null
  
)

export default component.exports